import { useMutation } from "@tanstack/react-query";
import api from "@lib/api/axios";
import { MutationConfig } from "@lib/api/query";
import { apiEnum } from "@shared/types/enums/apiEnum";

type PayLoadType = {
    organizerEmail: string;
    resourceId: number;
};

const addFavorite = async (payload: PayLoadType) => {
    const { data } = await api.post(apiEnum.addFavorites, payload);
    return data;
};

type AddFavoriteType = {
    mutationConfig?: MutationConfig<typeof addFavorite>;
};

export const useAddFavorite = ({ mutationConfig }: AddFavoriteType) => {
    return useMutation({
        ...mutationConfig,
        mutationFn: addFavorite,
    });
};